<template>
  <div>
    <form
      v-if="activePreset"
      :action="this.apiUrl + '/saverawuserdetails'"
      :class="`
        groovemail-form-raw-html-preset
        ${classPrefix}rounded
        ${classPrefix}border
        ${classPrefix}relative
        ${classPrefix}border-solid
        ${classPrefix}border-grey-200
        ${classPrefix}p-4 form-wrapper
        ${classPrefix}bg-white
      `"
      :style="
          '--gp-bg-front-color:' + activePreset.styles.form.backgroundPatternFrontColor + ';' +
          '--gp-bg-front-alpha-color:' + (activePreset.styles.form.backgroundPatternFrontColor??'').replace('1)', '0.333)') + ';' +
          '--gp-bg-back-color:' + activePreset.styles.form.backgroundPatternBackColor + ';' +
          '--gp-bg-spacing:' + activePreset.styles.form.backgroundPatternSpacing + 'px;' +
          '--gp-bg-opacity:' + ((activePreset.styles.form.backgroundPatternOpacity??100)/100)+ ';' +
          'background-color:' + activePreset.styles.form.backgroundColor + ';' +
          'background-blur:' + (activePreset.styles.form.backgroundBlur??0) + 'px;' +
          'background:' + activePreset.styles.form.backgroundColor + ';' +
          'background:' + activePreset.styles.form.backgroundColor + ';' +
          'color:' + activePreset.styles.form.color + ';' +
          'padding: ' + activePreset.styles.form.padding.join('px ') + 'px;' +
          'margin: ' + activePreset.styles.form.margin.join('px ') + 'px;' +
          'border-width:' + activePreset.styles.form.border?.width.join('px ') + 'px;' +
          'border-radius:' + activePreset.styles.form.border?.radius.join('px ') + 'px;' +
          'border-color:' + activePreset.styles.form.border?.color.join(' ') + ';' +
          'border-style:' + activePreset.styles.form.border?.style.join(' ') + ';' +
          'background-size:' + activePreset.styles.form.backgroundSize + ';' +
          'background-position:' + activePreset.styles.form.backgroundPosition + ';' +
          'background-repeat:' + activePreset.styles.form.backgroundRepeat + ';' +
          'background-image:' + (activePreset.styles.form.backgroundImage == null ? 'none' : activePreset.styles.form.backgroundImage ) + ';' +
          activePreset.styles.form.customStyles ?? ''
      "
      method="post"
    >
      <input type="hidden" name="formid" :value="this.mailform.id ?? this.mailform.formid" />
      <input
        type="hidden"
        name="ip_address"
        :value="this.ipaddress"
      />
      <input type="hidden" name="appUrl" :value="this.appUrl" />
      <input type="hidden" name="form_submit_type" value="raw_html" />
      <input type="hidden" :name="hiddenKey" value="" />

      <div
        v-if="mailform.form_heading && !model.fetched_form_fields.headings_v2"
        :style="
            'font-family:' + (activePreset.styles.heading.text.fontFamily || '') + ';' +
            'text-shadow:' + (activePreset.styles.heading.text.textShadow || '') + ';' +
            'font-size:' + activePreset.styles.heading.text.fontSize + 'px;' +
            'text-align:' + activePreset.styles.heading.text.textAlign + ';' +
            'font-style:' + (activePreset.styles.heading.text.fontStyle || '') + ';' +
            'font-weight:' + (activePreset.styles.heading.text.fontWeight || '') + ';' +
            'letter-spacing:' + (activePreset.styles.heading.text.letterSpacing || '') + ';' +
            'line-height:' + (activePreset.styles.heading.text.lineHeight || '') + ';' +
            '-webkit-text-stroke-width:' + (activePreset.styles.heading.text.textStrokeWidth || '') + ';' +
            '-webkit-text-stroke-color:' + (activePreset.styles.heading.text.textStrokeColor || '') + ';' +
            'text-decoration-line:' + (activePreset.styles.heading.text.textDecorationLine || '') + ';' +
            'padding: ' + activePreset.styles.heading.padding.join('px ') + 'px;' +
            'margin: ' + activePreset.styles.heading.margin.join('px ') + 'px;' +
            'color:' + activePreset.styles.heading.text.color + ';' +
            activePreset.styles.heading.customStyles ?? ''
        "
        :class="`${classPrefix}text-xl ${classPrefix}font-bold ${classPrefix}outline-none ${classPrefix}relative ${classPrefix}text-center`"
      >
        {{ mailform.form_heading }}
      </div>
      <div
        v-if="mailform.form_sub_heading && !model.fetched_form_fields.headings_v2"
        :style="
            'font-family:' + (activePreset.styles.subheading.text.fontFamily || '') + ';' +
            'text-shadow:' + (activePreset.styles.subheading.text.textShadow || '') + ';' +
            'font-size:' + activePreset.styles.subheading.text.fontSize + 'px;' +
            'text-align:' + activePreset.styles.subheading.text.textAlign + ';' +
            'font-style:' + (activePreset.styles.subheading.text.fontStyle || '') + ';' +
            'font-weight:' + (activePreset.styles.subheading.text.fontWeight || '') + ';' +
            'letter-spacing:' + (activePreset.styles.subheading.text.letterSpacing || '') + ';' +
            'line-height:' + (activePreset.styles.subheading.text.lineHeight || '') + ';' +
            '-webkit-text-stroke-width:' + (activePreset.styles.subheading.text.textStrokeWidth || '') + ';' +
            '-webkit-text-stroke-color:' + (activePreset.styles.subheading.text.textStrokeColor || '') + ';' +
            'text-decoration-line:' + (activePreset.styles.subheading.text.textDecorationLine || '') + ';' +
            'padding: ' + activePreset.styles.subheading.padding.join('px ') + 'px;' +
            'margin: ' + activePreset.styles.subheading.margin.join('px ') + 'px;' +
            'color:' + activePreset.styles.subheading.text.color + ';' +
            activePreset.styles.subheading.customStyles ?? ''
        "
        :class="`${classPrefix}text-sm ${classPrefix}text-grey-700 ${classPrefix}mt-1 ${classPrefix}mb-10 ${classPrefix}relative ${classPrefix}outline-none ${classPrefix}text-center`"
      >
        {{ mailform.form_sub_heading }}
      </div>

      <div
        :class="[{[`${classPrefix}flex ${classPrefix}flex-row`]: model.fetched_form_fields.layout_type == 'horizontal'}, `${classPrefix}relative ${classPrefix}mt-10`]"
      >
      <div
        :class="`${classPrefix}w-full ${classPrefix}flex ${classPrefix}space-x-4`"
        v-for="(row, indexRow) in htmlRawRows"
      >
        <div
          v-for="(column, indexCol) in row"
          :class="[{
            [`${classPrefix}w-full`]: column.width==100,
            [`${classPrefix}w-1/2`]: column.width==50,
            [`${classPrefix}w-1/3`]: column.width==33,
            [`sm:${classPrefix}flex-row ${classPrefix}flex`]: model.fetched_form_fields.layout_type == 'horizontal',
            [`sm:${classPrefix}flex-col ${classPrefix}flex`]: model.fetched_form_fields.layout_type != 'horizontal',
          }, `${classPrefix}flex-col`]"
          class="formColumn2"
        >
          <div
            v-for="(element, mainindex) in column.fields"
            :style="'background-color:' + activePreset.styles.color"
            :key="mainindex"
            :class="`${classPrefix}w-full`"
          >
            <div
              v-if="['paragraph', 'heading', 'subheading'].includes(element.type)"
            >
              <div
                :class="[`${classPrefix}inner-p-0`]"
                :style="
                'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                'font-size:' + getStyle(element).text.fontSize + 'px;' +
                'text-align:' + getStyle(element).text.textAlign + ';' +
                'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                'color:' + getStyle(element).text.color + ';' +
                'padding:' + (getStyle(element).padding ? getStyle(element).padding.join('px ') + 'px;' : ';') +
                'margin:' + (getStyle(element).margin ? getStyle(element).margin.join('px ') + 'px;' : ';') +
                getStyle(element).customStyles + ';'
                "
                v-html="element.placeholder"
              ></div>
            </div>
          <div
            v-if="element.type === 'accept'"
          >
            <div
              :class="`${classPrefix}flex`"
              :style="
                'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                'font-size:' + getStyle(element).text.fontSize + 'px;' +
                'justify-content: ' + getStyle(element).text.textAlign + ';' +
                'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                'color:' + getStyle(element).text.color + ';' +
                getStyle(element).customStyles + ';'
              "
            >
              <label class="container text-sm" style="display:inline-box; width:auto">
                {{ element.placeholder }}
                <input
                  :id="
                    element.fieldtype === 'standard'
                      ? element.name + '[]_' + (mailform.id ?? mailform.formid)
                      : element.identifier + '[]_' + (mailform.id ?? mailform.formid)
                  "
                  type="checkbox"
                  value="accepted"
                  :required="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                      ? true
                      : false
                  "
                  :name="
                    element.fieldtype === 'standard'
                      ? element.name + '[]'
                      : element.identifier + '[]'
                  "
                />
                <span
                  class="checkmark"
                  :style="
                    '--form-style-color:' + getStyle(element).iconColor + ';' +
                    '--form-style-background:' + getStyle(element).backgroundColor"
                ></span>
              </label>
            </div>
          </div>
            <div
              v-if="
                (element.type === 'textbox' || element.type === 'datepicker') &&
                element.name != 'phone_number'
              "
              :style="
                'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                'color:' + getStyle(element).text.color + ';'
              "
              :class="[`${classPrefix}mb-4`]"
            >
              <p
                :class="`${classPrefix}font-semibold ${classPrefix}text-sm ${classPrefix}mb-2`"
                v-if="!model.fetched_form_fields.hide_labels"
                :style="
                  'text-align: ' + getStyle(element).text.textAlign + ';' +
                  'color: ' + getStyle(element).labelColor + ';'
                "
              >
                {{ element.placeholder }}
                <span
                  v-if="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                  "
                  style="color: red; font-weight: bold"
                  >*</span
                >
              </p>
              <div
                :class="`${classPrefix}w-full ${classPrefix}flex ${classPrefix}rounded-lg ${classPrefix}text-grey-600 ${classPrefix}relative`"
              >
                <input
                  v-if="element.type !== 'datepicker'"
                  :id="
                    element.fieldtype === 'standard'
                      ? element.name + '_' + (mailform.id ?? mailform.formid)
                      : element.identifier + '_' + (mailform.id ?? mailform.formid)
                  "
                  :pattern="
                    element.name === 'email' ? emailReg : '^.{1,}$'
                  "
                  :type="
                    element.name === 'email'
                      ? 'email'
                      : 'text'"
                  :placeholder="element.placeholder"
                  :class="`${classPrefix}px-3 ${classPrefix}leading-normal ${classPrefix}py-2 ${classPrefix}rounded-lg ${classPrefix}w-full focus:${classPrefix}outline-none`"
                  :required="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                      ? true
                      : false
                  "
                  :name="
                    element.fieldtype === 'standard'
                      ? element.name
                      : element.identifier
                  "
                  :style="
                    'background:' + getStyle(element).backgroundColor + ';' +
                    'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                    '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'height:auto;' +
                    'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                    'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                    'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                    'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                    getStyle(element).customStyles + ';'
                  "
                />
                <input
                  v-if="element.type === 'datepicker'"
                  :id="
                    element.fieldtype === 'standard'
                      ? element.name + '_' + (mailform.id ?? mailform.formid)
                      : element.identifier + '_' + (mailform.id ?? mailform.formid)
                  "
                  :pattern="
                    element.name === 'email' ? emailReg : '^.{1,}$'
                  "
                  :type="
                    element.name === 'email'
                      ? 'email'
                      : 'text'"
                  onfocusin="this.type = 'date'"
                  onfocusout="this.value == '' ? this.type = 'text' : this.type = 'date'"
                  :placeholder="element.placeholder"
                  :class="`${classPrefix}px-3 ${classPrefix}leading-normal ${classPrefix}py-2 ${classPrefix}rounded-lg ${classPrefix}w-full focus:${classPrefix}outline-none`"
                  :required="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                      ? true
                      : false
                  "
                  :name="
                    element.fieldtype === 'standard'
                      ? element.name
                      : element.identifier
                  "
                  :style="
                    'background:' + getStyle(element).backgroundColor + ';' +
                    'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                    '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'height:auto;' +
                    'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                    'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                    'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                    'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                    getStyle(element).customStyles + ';'
                  "
                />
                <span
                  :class="`${classPrefix}absolute`"
                  v-if="
                  (element.mandatory === true ||
                  element.mandatory === 1 ||
                  element.mandatory === 'true') &&
                  model.fetched_form_fields.hide_labels
                  "
                  :style="
                  'color: #ff0000; font-weight: bold; right: 16px;' +
                  'top:' + (getStyle(element).padding[0]) + 'px;' +
                  (getStyle(element).text.textAlign == 'right' ?
                  'left:' + (10) + 'px;' :
                  'right:' + (10) + 'px;' )
                  "
                >*</span>
              </div>
            </div>
            <div
              v-if="
                element.type === 'textbox' &&
                element.name === 'phone_number'
              "
              :class="[`${classPrefix}mb-4`]"
              :style="
                'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                'color:' + getStyle(element).text.color + ';'
              "
            >
              <p
                :class="`${classPrefix}font-semibold ${classPrefix}text-sm ${classPrefix}mb-2`"
                v-if="!model.fetched_form_fields.hide_labels"
                :style="
                  'text-align: ' + getStyle(element).text.textAlign + ';' +
                  'color: ' + getStyle(element).labelColor + ';'
                "
              >
                {{ element.placeholder }}
                <span
                  v-if="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                  "
                  style="color: red; font-weight: bold"
                  >*</span
                >
              </p>
              <div
                :class="`${classPrefix}w-full ${classPrefix}flex ${classPrefix}items-center ${classPrefix}rounded-lg`"
              >
                <div
                  :id="`telephone_input${mailform.id}`"
                  :class="`${classPrefix}w-1/3 ${classPrefix}relative`"
                  :style="
                    'background:' + getStyle(element).backgroundColor + ';' +
                    'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                    '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'height:auto;' +
                    'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                    'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                    'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                    'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                    getStyle(element).customStyles + ';' +
                    'margin-right: 0px;' +
                    'border-bottom-right-radius: 0px;' +
                    'border-top-right-radius: 0px;' +
                    'border-right: 0px;'
                  "
                >
                  <i
                    :class="`${classPrefix}absolute ${classPrefix}w-3 fa fa-caret-down`"
                    aria-hidden="true"
                  ></i>
                </div>
                <input
                  :id="
                    element.fieldtype === 'standard'
                      ? element.name + '_' + (mailform.id ?? mailform.formid)
                      : element.identifier + '_' + (mailform.id ?? mailform.formid)
                  "
                  pattern="[0-9]{6,12}"
                  type="tel"
                  :placeholder="element.placeholder"
                  :class="`${classPrefix}w-2/3 ${classPrefix}leading-normal ${classPrefix}px-3 ${classPrefix}py-2 ${classPrefix}rounded-lg focus:${classPrefix}outline-none`"
                  :required="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                      ? true
                      : false
                  "
                  :name="
                    element.fieldtype === 'standard'
                      ? element.name
                      : element.identifier
                  "
                  :style="
                    'background:' + getStyle(element).backgroundColor + ';' +
                    'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                    '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'height:auto;' +
                    'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                    'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                    'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                    'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                    getStyle(element).customStyles + ';' +
                    'margin-left: 0px;' +
                    'border-bottom-left-radius: 0px;' +
                    'border-top-left-radius: 0px;'
                  "
                />
              </div>
            </div>
            <div
              v-if="element.type === 'textarea'"
              :style="
                'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                'color:' + getStyle(element).text.color + ';'
              "
              :class="[`${classPrefix}mb-4`]"
            >
              <p
                :class="`${classPrefix}font-semibold ${classPrefix}text-sm ${classPrefix}mb-2`"
                v-if="!model.fetched_form_fields.hide_labels"
                :style="
                  'color:' + getStyle(element).labelColor + ';' +
                  'text-align: ' + getStyle(element).text.textAlign + ';'
                "
              >
                {{ element.placeholder }}
                <span
                  v-if="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                  "
                  style="color: red; font-weight: bold"
                  >*</span
                >
              </p>
              <div
                :class="`${classPrefix}w-full ${classPrefix}rounded-lg ${classPrefix}text-grey-600`"
              >
                <textarea
                  :id="
                    element.fieldtype === 'standard'
                      ? element.name + '_' + (mailform.id ?? mailform.formid)
                      : element.identifier + '_' + (mailform.id ?? mailform.formid)
                  "
                  rows="4"
                  :class="`${classPrefix}px-3 ${classPrefix}leading-normal ${classPrefix}py-2 ${classPrefix}rounded-lg ${classPrefix}w-full ${classPrefix}resize-none focus:${classPrefix}outline-none`"
                  :placeholder="model.fetched_form_fields.hide_labels ? element.placeholder : ''"
                  :required="
                    element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true'
                      ? true
                      : false
                  "
                  :name="
                    element.fieldtype === 'standard'
                      ? element.name
                      : element.identifier
                  "
                  :style="
                    'background:' + getStyle(element).backgroundColor + ';' +
                    'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                    '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'height:auto;' +
                    'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                    'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                    'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                    'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                    getStyle(element).customStyles + ';'
                  "
                ></textarea>
              </div>
            </div>
            <div
              v-if="element.type === 'dropdown'"
              :style="
                'color:' + getStyle(element).text.color + ';'
              "
            >
              <div
                :class="`${classPrefix}text-left`"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'text-align: ' + getStyle(element).text.textAlign + ';'
                "
              >
                <p
                  :class="`${classPrefix}font-semibold ${classPrefix}mb-2 ${classPrefix}text-sm`"
                  v-if="!model.fetched_form_fields.hide_labels"
                  :style="
                    'color: ' + getStyle(element).labelColor + ';'
                  "
                >
                  {{ element.label }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    style="color: red; font-weight: bold"
                    >*</span
                  >
                </p>
                <div
                  :class="`${classPrefix}mt-2 ${classPrefix}relative`"
                >
                  <i
                    :class="`${classPrefix}absolute ${classPrefix}w-3 fa fa-caret-down`"
                    aria-hidden="true"
                  ></i>
                  <select
                    style="padding-top: 7px; padding-bottom: 7px"
                    :class="`${classPrefix}w-full ${classPrefix}leading-normal ${classPrefix}px-3 ${classPrefix}py-2 ${classPrefix}rounded-lg ${classPrefix}text-grey-600 focus:${classPrefix}outline-none`"
                    :required="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                        ? true
                        : false
                    "
                    :name="
                      element.fieldtype === 'standard'
                        ? element.name
                        : element.identifier
                    "
                    :style="
                      'background:' + getStyle(element).backgroundColor + ';' +
                      'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                      '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                      'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                      'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                      'font-size:' + getStyle(element).text.fontSize + 'px;' +
                      'text-align:' + getStyle(element).text.textAlign + ';' +
                      'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                      'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                      'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                      'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                      '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                      '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                      'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                      'color:' + getStyle(element).text.color + ';' +
                      'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                      'height:auto;' +
                      'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                      'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                      'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                      'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                      getStyle(element).customStyles + ';'
                    "
                  >
                    <option
                      disabled
                      v-if="model.fetched_form_fields.hide_labels"
                      selected
                    >{{element.label}}</option>
                    <option
                      v-for="(option, index) in element.options"
                      :key="index"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div
              v-if="element.type === 'radio'"
            >
              <div
                :class="`${classPrefix}w-full ${classPrefix}text-left`"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'text-align: ' + getStyle(element).text.textAlign + ';' +
                  'color:' + getStyle(element).text.color + ';' +
                  getStyle(element).customStyles + ';'
                "
              >
                <p
                  :class="`${classPrefix}font-semibold ${classPrefix}text-sm`"
                  style="margin:0"
                  :style="
                    'color: ' + getStyle(element).labelColor + ';'
                  "
                >
                  {{ element.label }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    style="color: red; font-weight: bold"
                    >*</span
                  >
                </p>
                <div
                  :style="
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'text-align:' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    getStyle(element).customStyles + ';'
                  "
                >
                  <div
                    v-for="(value, index) in element.options"
                    :key="index"
                    :style="
                      'justify-content: ' + getStyle(element).text.textAlign + ';'
                    "
                    :class="`${classPrefix}mt-2 ${classPrefix}flex`"
                  >
                    <label
                      :class="`radio-container ${classPrefix}mt-1 ${classPrefix}text-sm`"
                    >
                      {{ value }}
                      <input
                        :id="
                          element.fieldtype === 'standard'
                            ? element.name + '_' + (mailform.id ?? mailform.formid)
                            : element.identifier + '_' + (mailform.id ?? mailform.formid)
                        "
                        type="radio"
                        :value="value"
                        :class="`${classPrefix}w-6 ${classPrefix}leading-normal ${classPrefix}h-6 ${classPrefix}mr-10`"
                        :required="
                          element.mandatory === true ||
                          element.mandatory === 1 ||
                          element.mandatory === 'true'
                            ? true
                            : false
                        "
                        :name="
                          element.fieldtype === 'standard'
                            ? element.name
                            : element.identifier
                        "
                      />
                      <span
                        class="radio-checkmark"
                        :style="
                          '--form-style-color:' + getStyle(element).iconColor + ';' +
                          '--form-style-background:' + getStyle(element).backgroundColor"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="element.type === 'checkbox'"
            >
              <div
                :class="`${classPrefix}w-full ${classPrefix}text-left`"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'text-align: ' + getStyle(element).text.textAlign + ';' +
                  'color:' + getStyle(element).text.color + ';' +
                  getStyle(element).customStyles + ';'
                "
              >
                <p
                  :class="`${classPrefix}font-semibold ${classPrefix}text-sm`"
                  style="margin:0"
                  :style="
                    'color: ' + getStyle(element).labelColor + ';'
                  "
                >
                  {{ element.label }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    style="color: red; font-weight: bold"
                    >*</span
                  >
                </p>
                <div
                  :style="
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'color:' + getStyle(element).text.color + ';'
                  "
                >
                  <div
                    v-for="(value, index) in element.options"
                    :key="index"
                    :class="`${classPrefix}mt-2 ${classPrefix}flex`"
                    :style="
                      'justify-content: ' + getStyle(element).text.textAlign + ';' +
                      'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                      'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                      'font-size:' + getStyle(element).text.fontSize + 'px;' +
                      'text-align:' + getStyle(element).text.textAlign + ';' +
                      'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                      'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                      'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                      'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                      '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                      '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                      'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                      'color:' + getStyle(element).text.color + ';' +
                      getStyle(element).customStyles + ';'
                    "
                  >
                    <label
                      :class="`container ${classPrefix}pt-1 ${classPrefix}text-sm`"
                      style="display: inline-block; width: auto;"
                    >
                      <div v-if="typeof value == 'string'">
                        {{ value}}
                      </div>
                      <div v-else>
                        <a
                          style="text-decoration: underline"
                          target="_blank"
                          :href="value.link"
                        >{{ value.text }}</a>
                      </div>
                      <input
                        :id="
                          element.fieldtype === 'standard'
                            ? element.name + '[]_' + (mailform.id ?? mailform.formid)
                            : element.identifier + '[]_' + (mailform.id ?? mailform.formid)
                        "
                        type="checkbox"
                        :class="`${classPrefix}mr-10 ${classPrefix}leading-normal`"
                        :value="value"
                        :required="
                          element.mandatory === true ||
                          element.mandatory === 1 ||
                          element.mandatory === 'true'
                            ? true
                            : false
                        "
                        :name="
                          element.fieldtype === 'standard'
                            ? element.name + '[]'
                            : element.identifier + '[]'
                        "
                      />
                      <span
                        class="checkmark"
                        :style="
                          '--form-style-color:' + getStyle(element).iconColor + ';' +
                          '--form-style-background:' + getStyle(element).backgroundColor"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          <div

            v-if="element.type == 'submit'"
            :class="`${classPrefix}flex ${classPrefix}w-full ${classPrefix}items-end ${classPrefix}h-full`">
        <div
          :class="[`${classPrefix}w-full ${classPrefix}mb-4 ${classPrefix}flex`,{
            [`${classPrefix}justify-start`]: activePreset.styles.button.alignment == 'left',
            [`${classPrefix}justify-end`]: activePreset.styles.button.alignment == 'right',
            [`${classPrefix}justify-center`]: activePreset.styles.button.alignment == 'center',
          }]"
        >
          <button
            size="expand"
            style="background: #2f80ed"
            :class="[`${classPrefix}leading-normal ${classPrefix}rounded ${classPrefix}text-white ${classPrefix}px-6 ${classPrefix}py-2 ${classPrefix}mt-3 focus:${classPrefix}outline-none`, {
              [`${classPrefix}w-full`]: activePreset.styles.button.alignment == 'full',
            }]"
            type="submit"
            :style="
              'height: auto;' +
              'background:' + activePreset.styles.button.backgroundColor + ';' +
              'box-shadow:' + (activePreset.styles.button.boxShadow ?? '') + ';' +
              'margin:' + activePreset.styles.button.margin + 'px;' +
              'padding: ' + activePreset.styles.button.padding.join('px ') + 'px;' +
              'margin: ' + activePreset.styles.button.margin.join('px ') + 'px;' +
              'border-width:' + activePreset.styles.button.border?.width.join('px ') + 'px;' +
              'border-radius:' + activePreset.styles.button.border?.radius.join('px ') + 'px;' +
              'border-color:' + activePreset.styles.button.border?.color.join(' ') + ';' +
              'border-style:' + activePreset.styles.button.border?.style.join(' ') + ';' +
              'font-family:' + (activePreset.styles.button.text.fontFamily || '') + ';' +
              'text-shadow:' + (activePreset.styles.button.text.textShadow || '') + ';' +
              'font-size:' + activePreset.styles.button.text.fontSize + 'px;' +
              'text-align:' + activePreset.styles.button.text.textAlign + ';' +
              'font-style:' + (activePreset.styles.button.text.fontStyle || '') + ';' +
              'font-weight:' + (activePreset.styles.button.text.fontWeight || '') + ';' +
              'letter-spacing:' + (activePreset.styles.button.text.letterSpacing || '') + ';' +
              'line-height:' + (activePreset.styles.button.text.lineHeight || '') + ';' +
              '-webkit-text-stroke-width:' + (activePreset.styles.button.text.textStrokeWidth || '') + ';' +
              '-webkit-text-stroke-color:' + (activePreset.styles.button.text.textStrokeColor || '') + ';' +
              'text-decoration-line:' + (activePreset.styles.button.text.textDecorationLine || '') + ';' +
              'color:' + activePreset.styles.button.text.color + ';' +
              activePreset.styles.button.customStyles + ';'
            "
          >
            {{
              mailform.form_submit_button_text
                ? mailform.form_submit_button_text
                : $t('frontend_send')
            }}
            <div
              :style="
                'margin:' + activePreset.styles.button_sublabel.margin + 'px;' +
                'padding: ' + activePreset.styles.button_sublabel.padding.join('px ') + 'px;' +
                'margin: ' + activePreset.styles.button_sublabel.margin.join('px ') + 'px;' +
                'font-family:' + (activePreset.styles.button_sublabel.text.fontFamily || '') + ';' +
                'text-shadow:' + (activePreset.styles.button_sublabel.text.textShadow || '') + ';' +
                'font-size:' + activePreset.styles.button_sublabel.text.fontSize + 'px;' +
                'text-align:' + activePreset.styles.button_sublabel.text.textAlign + ';' +
                'font-style:' + (activePreset.styles.button_sublabel.text.fontStyle || '') + ';' +
                'font-weight:' + (activePreset.styles.button_sublabel.text.fontWeight || '') + ';' +
                'letter-spacing:' + (activePreset.styles.button_sublabel.text.letterSpacing || '') + ';' +
                'line-height:' + (activePreset.styles.button_sublabel.text.lineHeight || '') + ';' +
                '-webkit-text-stroke-width:' + (activePreset.styles.button_sublabel.text.textStrokeWidth || '') + ';' +
                '-webkit-text-stroke-color:' + (activePreset.styles.button_sublabel.text.textStrokeColor || '') + ';' +
                'text-decoration-line:' + (activePreset.styles.button_sublabel.text.textDecorationLine || '') + ';' +
                'color:' + activePreset.styles.button_sublabel.text.color + ';' +
                activePreset.styles.button_sublabel.customStyles + ';'
              "
              :class="`${classPrefix}block`"
              v-if="model.fetched_form_fields.button_sublabel"
            >
              {{ model.fetched_form_fields.button_sublabel }}
            </div>
          </button>
        </div>
      </div>
          </div>
    </div>
  </div>

      </div>
      <div :class="activePreset.styles.form.backgroundPattern+'-pattern'" class="pattern-background"></div>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import createKey from '@/components/createHiddenKey.js';

export default {
  name: 'HtmlRawForm',

  props: {
    activePreset: {
      required:true,
    },
    mailform: {
      required: true,
    },
    classPrefix: {
      default: 'groovemail-form-raw-html-embed-'
    },
  },

  data(){
    return {
      ipaddress: false,
      apiUrl: '',
      appUrl: '',
      emailReg:
        '[_a-zA-Z0-9-]+(.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})',
      hiddenKey: '',
      model: {
        fetched_form_fields: [],
      }
    }
  },

  computed: {
    htmlRawRows() {
      if(this.model.fetched_form_fields.layout_type != 'custom'){
        return [
          [
            { width: 100, fields: this.model.fetched_form_fields.fields }
          ]
        ];
      }
          let form_fields = this.model.fetched_form_fields;
          let fields_on_rows = [...form_fields.rows.map((i) => i.map((e) => e.fields)).flat(2)];
          if(fields_on_rows.length != form_fields.fields.length){
            form_fields.fields.forEach(i => {
              if(!fields_on_rows.find(f => f == i.id)){
                form_fields.rows[form_fields.rows.length - 1][0].fields.push(i.id);
              }
            });
          }
          return form_fields.rows.map(
            a => a.map(
              e => {
                e.fields = e.fields.map(
                  o => {
                    return form_fields.fields.find(
                      f => f.id == o
                    );
                  });
                e.fields = e.fields.filter(
                  o => o !== undefined
                );
                return e
              }
            )
          );
s
    },
  },

  mounted: async function () {
    this.hiddenKey = createKey(8);
    this.model.fetched_form_fields = JSON.parse(JSON.stringify(this.mailform.form_fields));
    if(typeof this.model.fetched_form_fields == 'string'){
      this.model.fetched_form_fields = JSON.parse(this.model.fetched_form_fields);
    }
    this.apiUrl = window.config.apiUrl;
    this.appUrl = window.config.grooveappsurl;
  },

  created: async function () {
    //
  },

  watch: {
    mailform: {
      handler(newVal){
        this.model.fetched_form_fields = JSON.parse(JSON.stringify(newVal.form_fields));
        if(typeof this.model.fetched_form_fields == 'string'){
          this.model.fetched_form_fields = JSON.parse(this.model.fetched_form_fields);
        }
      }
    }
  },
  methods: {
    getStyle(element){
      let type = element.type;
      let id = element.id
      if (type == 'paragraph') {
        type = 'paragraphs';
      }
      if (!['paragraph', 'heading', 'subheading'].includes(element.type)) {
        type = 'field';
      }
      let advancedStyles = {};
      if(
        this.activePreset.styles.advanced &&
        this.activePreset.styles.advanced.fields &&
        this.activePreset.styles.advanced.fields[id]
      ){
        advancedStyles = this.activePreset.styles.advanced.fields[id];
      }

      return {...this.activePreset.styles[type], ...advancedStyles};
    },
  },
  components: {
    //
  }
}
</script>
<style>
.min-h-10{
  min-height:100px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.form-row, .formColumn {
  position: relative;
  border: dashed 1px #ccc;
  margin: 5px;
}
.form-row {
  position: relative;
}
.formColumn:before {
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    left: 0px;
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 0px 0px 5px 0px;
    top: 0px;
}
.form-row:before {
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    left: calc(50% - 10px);
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 5px 5px 0px 0px;
    top: -20px;
}
.form-builder-wrapper:before{
    border: 1px solid #767070ad;
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 5px;
    top: calc(50% - 10px);
    left: -16px;
    z-index: 10;

}
.form-builder-wrapper{
  position:relative
}
.form-row:hover:before, .formColumn:hover:before, .form-builder-wrapper:hover:before {
  display:block;
}

.formPlaceholder {
  background: #00000020;
  padding: 10px;
  padding-top: 20px;
  padding-bottom: 0px;
}
.delete_col {
  display: none;
      background: #fff;
    position: absolute;
    border-radius: 0 0 0 5px;
    right: -1px;
    top: -1px;
    cursor: pointer;
}
.formColumn:hover .delete_col, .form-row:hover .delete_row {
  display: block;
}
.delete_row{

  display: none;
      background: #fff;
    position: absolute;
    border-radius: 0 0 0 5px;
    cursor: pointer;
    top: -25px;
    cursor: pointer;
    left: calc(50% - -11px);
  }

.groovemail-form-preset .container input:checked ~ .checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .container .checkmark:after {
  border-color: var(--form-style-color)!important;
}

.groovemail-form-preset .radio-container input:checked ~ .radio-checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .radio-container .radio-checkmark:after {
  background: var(--form-style-color)!important;
}
.groovemail-form-preset input::placeholder, .groovemail-form-preset textarea::placeholder {
  color: var(--form-style-placeholder-color)!important;
}
</style>
